export default "__VITE_ASSET__ijphuFJb__"